<template>
  <div class="general">
    <div class="section1">
      <div class="item1">
        <layout1 :title="title1">
          <div class="box">
            <div class="left vflex">
              <div class="top">{{ electData.todayUseElect | genderMenu }}</div>
              <div class="bottom">
                {{ title2 }}：{{ electData.compareUseElect | getTwo}}kWh
              </div>
            </div>
            <div class="middle vflex">
              <div class="top">kWh</div>
              <div class="bottom">
                <span>同比 </span>
                <!-- <img src="../../assets/images/icon/icon5.png" /> -->
                <span> {{ electData.tb*100 | getTwo}}%</span>
              </div>
            </div>
            <div class="br"></div>
            <div class="right vflex">
              <img src="../../assets/images/icon/icon8.png" />
              <p class="top">负载率</p>
              <p class="bottom">{{ electData.loadRate==='-'?'- - -':electData.loadRate*100 | getFour }}<span
                  v-if="electData.loadRate!=='-'">%</span></p>
            </div>
            <div class="change-date">
              <p :class="index == dateValue1 ? 'active' : ''" v-for="(item, index) in changeDate" :key="index"
                @click="dateValue1 = index">
                {{ item }}
              </p>
            </div>
          </div>
        </layout1>
      </div>
      <div class="item2">
        <layout1 :title="'今日告警数'">
          <div class="box">
            <div class="left">
              <p>{{ alarmNumbers.alarmTotal }}</p>
              <p>项</p>
            </div>
            <div class="middle">
              <div class="top">
                <div class="legend"></div>
                <p>待处理告警</p>
              </div>
              <div class="bottom">
                <p>{{ alarmNumbers.alarmUnHandle }}</p>
                <p>项</p>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <div class="legend"></div>
                <p>已处理告警</p>
              </div>
              <div class="bottom">
                <p>{{ alarmNumbers.alarmHandle }}</p>
                <p>项</p>
              </div>
            </div>
          </div>
          <div class="progress">
            <div class="inner">
              <div class="pro" :style="{
                      width:
                        alarmNumbers.alarmTotal===0?0+'%':(alarmNumbers.alarmUnHandle / alarmNumbers.alarmTotal)*100 +'%' ,
                    }"></div>
            </div>
          </div>
        </layout1>
      </div>
      <div class="item3">
        <layout1 :title="'环境状态'">
          <div class="box">
            <div class="item">
              <img src="../../assets/images/icon/icon12.png" />
              <p>
                <span>温湿度：</span>
                <span>正常</span>
              </p>
            </div>
            <div class="item">
              <img src="../../assets/images/icon/icon7.png" />
              <p>
                <span>水浸：</span>
                <span style="color: rgba(229, 141, 110, 1)">正常</span>
              </p>
            </div>
          </div>
        </layout1>
      </div>
    </div>
    <div class="section2">
      <div class="item1">
        <layout1 :title="'实时告警'">
          <div class="table-box">
            <el-table :data="tableData" style="width: 100%" height="300">
              <el-table-column type="index" width="80" label="编号">
              </el-table-column>
              <el-table-column prop="roomName" width="150" label="配电室">
              </el-table-column>
              <el-table-column prop="equipmentType" width="220" label="设备分类">
                <template slot-scope="scope">
                  <div>{{ castObj[scope.row.equipmentType] }}</div>
                </template>
              </el-table-column>

              <el-table-column prop="alarmContent" label="报警内容">
              </el-table-column>
              <el-table-column prop="alarmTime" width="200" label="时间">
              </el-table-column>
              <el-table-column label="更多" width="200">
                <template>
                  <div class="btn-out-box">
                    <div class="btn-box download" title="查看详情" @click="toRight()">
                      <i class="iconfont icon-youxiang"></i>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </layout1>
      </div>

    </div>
    <div class="section3">
      <div class="item1">
        <layout1 :title="'用电趋势'">
          <div class="change-date">
            <p :class="index == dateValue2 ? 'active' : ''" v-for="(item, index) in changeDate" :key="index"
              @click="dateValue2 = index">
              {{ item }}
            </p>
          </div>
          <div class="box">
            <div class="left">
              <div class="top">
                <div class="info">
                  <span>最大负载时间：</span>
                  <span>{{ maxElectDate }}</span>
                </div>
                <div class="info">
                  <span>{{legend3}}</span>:
                  <span>{{ maxElect | getTwo}}kWh</span>
                </div>
                <div class="legend" style="margin-right: 28px">
                  <div class="color"></div>
                  <p>{{ legend1 }}</p>
                </div>
                <div class="legend">
                  <div class="color color2"></div>
                  <p>{{ legend2 }}</p>
                </div>
              </div>
              <div class="bottom">
                <v-chart :option="options" ref="chart"></v-chart>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <v-chart :option="options2" ref="chart2"></v-chart>
                <div class="info">
                  <div class="value">{{ allElectric | genderMenu }}</div>
                  <p class="label">总用电量</p>
                  <p class="unit">(kWh)</p>
                </div>
              </div>
              <div class="bottom">
                <div class="label" v-for="(item, index) in labelList" :key="index">
                  <div class="color" :style="{ background: item.color }"></div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </layout1>
      </div>
      <div class="item2">
        <layout1 :title="'项目概况'">
          <div class="box">
            <div class="item" v-for="(item, index) in projectsInfoList" :key="index">
              <div class="title">
                <img :src="item.icon" alt="" />
                <p>{{ item.name }}</p>
              </div>
              <div class="bottom">
                <div class="left">
                  <p></p>
                  <p></p>
                  <p></p>
                </div>
                <div class="right">
                  <span class="text-one" :title="item.value">{{ item.value }}</span>
                  <span> {{ item.unit }}</span>
                </div>
              </div>
            </div>
          </div>
        </layout1>
      </div>
    </div>
  </div>
</template>

<script>
  import layout1 from "../layout/layout1";
  import ECharts from "vue-echarts";
  export default {
    name: "general",
    data () {
      return {
        projectId: "",
        changeDate: ["日", "月", "年"],
        dateValue1: 0,
        // 当日总用电出现没有数据
        todayEleLoading: false,
        dateValue2: 0,
        tableData: [],
        options: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          color: ["rgba(0, 206, 124, 0.3)", "rgba(20, 96, 224, 1)"],
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [{
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            data: [],
          },],
          yAxis: [{
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },],
          series: [{
            name: "当日用电",
            type: "line",
            symbolSize: 0,
            itemStyle: {},
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "rgba(0, 206, 124, 0.3)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(0, 206, 124, 0)", // 100% 处的颜色
                },
                ],
                global: false, // 缺省为 false
              },
            },
            data: [],
          },
          {
            name: "上周同期",
            type: "line",
            symbolSize: 0,
            itemStyle: {},
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "rgba(20, 96, 224, 0.5)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(20, 96, 224, 0)", // 100% 处的颜色
                },
                ],
                global: false, // 缺省为 false
              },
            },
            data: [],
          },
          ],
        },
        options2: {
          color: ["#FADC88", "#4CDAA3", "#5A8FE8", "#FC6F93"],
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
          },
          series: [{
            name: "电量分布",
            type: "pie",
            radius: ["70%", "90%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            data: [{
              value: 0,
              name: "尖电量",
            },
            {
              value: 0,
              name: "峰电量",
            },
            {
              value: 0,
              name: "谷电量",
            },
            {
              value: 0,
              name: "平电量",
            },
            ],
          },],
        },
        allElectric: 0,
        labelList: [{
          color: "#FADC88",
          name: "尖电量",
        },
        {
          color: "#4CDAA3",
          name: "峰电量",
        },
        {
          color: "#5A8FE8",
          name: "谷电量",
        },
        {
          color: "#FC6F93",
          name: "平电量",
        },
        ],
        //
        projectsInfoList: [{
          icon: require("../../assets/images/icon/icon11.png"),
          name: "变配电室数量",
          value: "-",
          unit: "个",
        },
        {
          icon: require("../../assets/images/icon/icon13.png"),
          name: "变压器台数",
          value: "-",
          unit: "台",
        },
        {
          icon: require("../../assets/images/icon/icon10.png"),
          name: "监控回路",
          value: "-",
          unit: "台",
        },
        {
          icon: require("../../assets/images/icon/icon3.png"),
          name: "装机容量",
          value: "-",
          unit: "kVA",
        },
        {
          icon: require("../../assets/images/icon/icon14.png"),
          name: "电压等级",
          value: "-",
          unit: "kV  ",
        },
        {
          icon: require("../../assets/images/icon/icon4.png"),
          name: "申报需量",
          value: "-",
          unit: "kW",
        },
        ],
        electData: {},
        maxElect: 0,
        maxElectDate: "",
        elList: [],
        alarmNumbers: {}, // 告警数量
        title1: "当日总用电",
        title2: "上周同期",
        legend1: "当日用电",
        legend2: "上周同期",
        legend3: "最大小时用电量",
        subscribeFields: [],
        dateType: 1,
        castObj: {
          1: "高压主进表",
          2: "低压主进表",
          3: "高压回路表",
          4: "低压回路表",
          5: "直流屏设备",
          6: "综保",
          7: "温控",
          8: "温湿度",
          9: "水浸",
          10: "视频",
        },
      };
    },
    components: {
      layout1,
      "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");
      // 项目概况
      this.getData();
      this.getProjectDetail();
      // 饼图
      this.searchTipPeakValleyFlatTotal(1);
      // 时时监控
      this.searchEquipmentRoomList();
      // 今日告警数
      this.searchAlarmDataToday();
      // 告警内容
      this.searchAlarmContent();
      // 用电
      this.searchProjectElect(0, 1);
      // setInterval(() => {
      //   this.searchLoadRate();
      // }, 3600000*10)
    },
    watch: {
      dateValue1 (n, o) {
        this.searchProjectElect(1, n + 1);
        this.dateType = n + 1;
        // this.searchLoadRate()
        if (n == 0) {
          this.title1 = "当日总用电";
          this.title2 = "上周同期";
        } else if (n == 1) {
          this.title1 = "当月总用电";
          this.title2 = "上月同期";
        } else {
          this.title1 = "当年总用电";
          this.title2 = "上年同期";
        }
      },
      dateValue2 (n, o) {
        this.searchProjectElect(2, n + 1);
        this.dateType = n + 1;
        // this.searchLoadRate()
        this.searchTipPeakValleyFlatTotal(n + 1);
        if (n == 0) {
          this.legend1 = "当日用电";
          this.legend2 = "上周同期";
          // 当日
          this.legend3 = "最大小时用电量";
        } else if (n == 1) {
          this.legend1 = "当月用电";
          this.legend2 = "上月同期";
          this.legend3 = "最大日用电量";
        } else {
          this.legend1 = "当年用电";
          this.legend2 = "上年同期";
          this.legend3 = "最大月用电量";
        }
      },
      alarm (n) {
        n.data.alarmContent = n.data.alarmDesc;
        this.tableData.unshift(n.data);
        if (this.tableData.length > 5) {
          this.tableData.pop();
        }
      },
    },
    filters: {
      filteralarmType (v) {
        let type = {
          // 0: '',
          1: "报警",
          2: "预警",
        };
        return type[v];
      },
    },
    computed: {
      alarm () {
        return this.$store.state.alarmInfo;
      },
    },
    methods: {
      // routerChange(e) {
      //   document.cookie = "roomId=" + e.id;
      //   this.$router.push("index");
      // },
      // 实时监控
      searchEquipmentRoomList () {
        this.$http
          .post(
            // "bma-distribution-service/equipmentRoom/searchEquipmentRoomList",
            "bma-distribution-service/equipmentRoom/searchEquipmentRoomListForOverview", {
            projectId: this.projectId,
          }
          )
          .then((res) => {
            if (res.code == 200) {
              let parr = [];
              let arr = [];
              res.data.forEach((item, index) => {
                arr.push(item);
                if ((index + 1) % 3 == 0) {
                  parr.push(arr);
                  arr = [];
                } else if (index == res.data.length - 1) {
                  parr.push(arr);
                  arr = [];
                }
              });
              this.elList = parr;
            }
          });
      },
      toRight () {
        this.$router.push("/all/event");
      },
      getData () {
        this.$http
          .post("bma-distribution-service/overview/searchProjectOverview", {
            projectId: this.projectId,
          })
          .then((res) => {
            this.projectsInfoList[0].value = res.data.roomCounts;
            this.projectsInfoList[1].value = res.data.transformerCounts;
            this.projectsInfoList[2].value = res.data.loopCounts;
          });
      },
      getProjectDetail () {
        this.$http
          .post("bma-user-service/project/searchProjectDetail", {
            projectId: this.projectId,
          })
          .then((res) => {
            this.projectsInfoList[3].value = res.data.installedCapacity;
            this.projectsInfoList[4].value = res.data.voltageLevel;
            this.projectsInfoList[5].value = res.data.declareCapacity;
          });
      },
      // 专门用来请求负载率
      searchLoadRate () {
        this.todayEleLoading = true;
        let str = "YYYY-mm-dd";
        if (this.dateType == 2) {
          str = "YYYY-mm";
        } else if (this.dateType == 3) {
          str = "YYYY";
        }
        let date = this.$dateFormat(str, new Date());
        this.$shttp
          .post("bma-distribution-service/realTime/searchProjectElect", {
            date: date,
            dateType: this.dateType,
            projectId: this.projectId,
            dataType: "1",
          })
          .then((res) => {
            alert(res.data.loadRate);
            this.electData.loadRate = res.data.loadRate;
          });
      },
      searchProjectElect (type, dateType) {
        // type 0 概况和趋势都执行  1 只执行概况 2 只执行趋势
        // dateType 1日  2月  3年
        this.todayEleLoading = true;
        let str = "YYYY-mm-dd";
        if (dateType == 2) {
          str = "YYYY-mm";
        } else if (dateType == 3) {
          str = "YYYY";
        }
        let date = this.$dateFormat(str, new Date());
        this.$http
          .post("bma-distribution-service/realTime/searchProjectElect", {
            date: date,
            dateType: dateType,
            projectId: this.projectId,
            dataType: "1",
          })
          .then((res) => {
            if (type == 0 || type == 1) {
              // 用电概况
              this.electData = res.data;
              this.todayEleLoading = false;
              // 实时监控
              this.subscribeElect(res.data.subscribeFields, dateType);
            }
            if (type == 0 || type == 2) {
              // 实时监控
              this.subscribeElect2(res.data.subscribeFields, dateType);
              // 用电趋势
              let useElectrics = res.data.useElectrics;
              //  let useElectrics = [{"date":0,"electric":"1111.034","lastElectric":"","tb":""},{"date":1,"electric":"1186.809","lastElectric":"","tb":""}]
              // let compareUseElectrics = [{"date":0,"electric":"1111.034","lastElectric":"","tb":""},{"date":1,"electric":"1186.809","lastElectric":"","tb":""}]
              let compareUseElectrics = res.data.compareUseElectrics;
              // x轴
              let iFlag = 0;
              let xAxis = [];
              // 截至时间
              let newFlag = 0;
              let ii = 0;
              if (dateType == 1) {
                iFlag = 23;
                for (let i = 0; i <= 23; i++) {
                  xAxis.push(i + "时");
                }
                newFlag = new Date().getHours();
              } else if (dateType == 2) {
                ii = 1;
                iFlag = 31;
                for (let i = 1; i <= 31; i++) {
                  xAxis.push(i + "日");
                }
                newFlag = new Date().getDate();
              } else if (dateType == 3) {
                ii = 1;
                iFlag = 12;
                for (let i = 1; i <= 12; i++) {
                  xAxis.push(i + "月");
                }
                newFlag = new Date().getMonth() + 1;
              }
              // 已有的时间list
              let dateList1 = [];
              let dateList2 = [];
              // 数据list
              let data1 = [];
              let data2 = [];
              // 求最大电量和用电时间
              let maxElect = 0;
              let maxElectDate = "";
              if (useElectrics) {
                useElectrics.forEach((item) => {
                  dateList1.push(item.date);
                  if (Number(item.electric) > maxElect) {
                    maxElect = Number(item.electric);
                    maxElectDate = item.date;
                  }
                });
              }
              if (compareUseElectrics) {
                compareUseElectrics.forEach((item) => {
                  dateList2.push(item.date);
                });
              }
              for (let i = ii; i <= iFlag; i++) {
                let index1 = dateList1.indexOf(i);
                if (index1 > -1) {
                  data1.push(this.$genderMenu(useElectrics[index1].electric));
                } else if (index1 == -1 && i <= newFlag) {
                  data1.push(0);
                } else {
                  data1.push("");
                }
                let index2 = dateList2.indexOf(i);
                if (index2 > -1) {
                  data2.push(
                    this.$genderMenu(compareUseElectrics[index2].electric)
                  );
                } else {
                  data2.push('');
                }
              }
              this.options.xAxis[0].data = xAxis;
              this.options.series[0].name = this.legend2;
              this.options.series[1].name = this.legend1;
              this.options.series[0].data = data2;
              this.options.series[1].data = data1;
              this.$refs.chart.setOption(this.options, true);
              this.maxElect = maxElect;
              if (dateType == 1) {
                maxElectDate = maxElectDate + "时";
              } else if (dateType == 2) {
                maxElectDate = maxElectDate + "日";
              } else if (dateType == 3) {
                maxElectDate = maxElectDate + "月";
              }
              this.maxElectDate = maxElectDate;
            }
          });
      },
      // 订阅总电量等
      subscribeElect (subscribeFields, dateType) {
        subscribeFields.forEach((item) => {
          if (
            item.subscribeField.indexOf("totalPower") > -1 ||
            item.subscribeField.indexOf("sameTerm") > -1 ||
            item.subscribeField.indexOf("sameCompare") > -1
          ) {
            if (this.subscribeFields.indexOf(item.subscribeField) == -1) {
              this.subscribeFields.push(item.subscribeField);
            }
            this.$timeing(
              item.subscribeField,
              item.subscribeField,
              (response) => {
                const body = JSON.parse(response.body);
                const field = body.field;
                const value = JSON.parse(body.value);
                if (value.type == dateType) {
                  if (field.indexOf("totalPower") > -1) {
                    this.electData.todayUseElect = value.data;
                  }
                  if (field.indexOf("sameTerm") > -1) {
                    this.electData.compareUseElect = value.data;
                  }
                  if (field.indexOf("sameCompare") > -1) {
                    this.electData.tb = value.data;
                  }
                }
              }
            );
          }
        });
      },
      subscribeElect2 (subscribeFields, dateType) {
        subscribeFields.forEach((item) => {
          if (
            item.subscribeField.indexOf("powerCurve") > -1 ||
            item.subscribeField.indexOf("lastPowerCurve") > -1
          ) {
            if (this.subscribeFields.indexOf(item.subscribeField) == -1) {
              this.subscribeFields.push(item.subscribeField);
            }
            this.$timeing(
              item.subscribeField,
              item.subscribeField,
              (response) => {
                const body = JSON.parse(response.body);
                const field = body.field;
                const value = JSON.parse(body.value);
                let innerIndex = "";
                if (dateType == 1) {
                  innerIndex = this.$dateFormat("HH", new Date(body.time)) - 0;
                } else if (dateType == 2) {
                  innerIndex = this.$dateFormat("dd", new Date(body.time)) - 1;
                } else {
                  innerIndex = this.$dateFormat("mm", new Date(body.time)) - 1;
                }
                if (value.type == dateType) {
                  if (field.indexOf("powerCurve") > -1) {
                    let temp = this.options.series[1].data[innerIndex] || 0;
                    this.options.series[1].data[innerIndex] = (
                      Number(temp) + Number(value.data)
                    ).toFixed(2);
                  }
                  if (field.indexOf("lastPowerCurve") > -1) {
                    let temp = this.options.series[0].data[innerIndex] || 0;
                    this.options.series[0].data[innerIndex] = (
                      0 + Number(value.data)
                    ).toFixed(2);
                  }
                  // console.log('chart'+this.$refs.chart)
                  // console.log('options'+JSON.stringify(this.options))
                  this.$refs.chart.setOption(this.options, true);
                }
              }
            );
          }
        });
      },
      // 根据项目按日期类型查看尖峰谷平总电量
      searchTipPeakValleyFlatTotal (dateType) {
        // type 0 概况和趋势都执行  1 只执行概况 2 只执行趋势
        // dateType 1日  2月  3年
        let str = "YYYY-mm-dd";
        if (dateType == 2) {
          str = "YYYY-mm";
        } else if (dateType == 3) {
          str = "YYYY";
        }
        let date = this.$dateFormat(str, new Date());
        this.$http
          .post(
            "bma-distribution-service/realTime/searchTipPeakValleyFlatTotal", {
            date: date,
            dateType: dateType,
            projectId: this.projectId,
            dataType: "1",
          }
          )
          .then((res) => {
            let allElectric = 0;
            if (res.data && res.data.tipPeakValleyFlatList) {
              this.options2.series[0].data = [{
                value: 0,
                name: "尖电量",
              },
              {
                value: 0,
                name: "峰电量",
              },
              {
                value: 0,
                name: "谷电量",
              },
              {
                value: 0,
                name: "平电量",
              },
              ];
              res.data.tipPeakValleyFlatList.forEach((item) => {
                this.options2.series[0].data[
                  item.type - 1
                ].value = this.$genderMenu(item.electric);
                allElectric += item.electric - 0;
              });
            }
            this.allElectric = allElectric;
            // 实时
            if (res.data && res.data.subscribeFields) {
              res.data.subscribeFields.forEach((item) => {
                if (this.subscribeFields.indexOf(item.subscribeField) == -1) {
                  this.subscribeFields.push(item.subscribeField);
                }
                this.$timeing(
                  item.subscribeField,
                  item.subscribeField,
                  (response) => {
                    const body = JSON.parse(response.body);
                    const field = body.field;
                    const value = JSON.parse(body.value);
                    if (value.type == dateType) {
                      if (field.indexOf("peakPower") > -1) {
                        this.options2.series[0].data[0].value = value.data;
                      }
                      if (field.indexOf("sharpPower") > -1) {
                        this.options2.series[0].data[1].value = value.data;
                      }
                      if (field.indexOf("grainPower") > -1) {
                        this.options2.series[0].data[2].value = value.data;
                      }
                      if (field.indexOf("flatPower") > -1) {
                        this.options2.series[0].data[3].value = value.data;
                      }
                      let all = 0;
                      this.options2.series[0].data.forEach((j) => {
                        all += j.value - 0;
                      });
                      this.allElectric = all;
                    }
                  }
                );
              });
            }
          });
      },
      // 今日告警数
      searchAlarmDataToday () {
        this.$http
          .post("bma-distribution-service/realTime/searchAlarmDataToday", {
            dataType: 1,
            projectId: this.projectId,
          })
          .then((res) => {
            this.alarmNumbers = res.data;
            // 实时
            if (res.data && res.data.subscribeFields) {
              res.data.subscribeFields.forEach((item) => {
                if (this.subscribeFields.indexOf(item.subscribeField) == -1) {
                  this.subscribeFields.push(item.subscribeField);
                }
                this.$timeing(
                  item.subscribeField,
                  item.subscribeField,
                  (response) => {
                    const body = JSON.parse(response.body);
                    const field = body.field;
                    if (field.indexOf("alarmTotal") > -1) {
                      this.alarmNumbers.alarmTotal = body.value;
                    }
                    if (field.indexOf("alarmUnHandle") > -1) {
                      this.alarmNumbers.alarmUnHandle = body.value;
                    }
                    if (field.indexOf("alarmHandle") > -1) {
                      this.alarmNumbers.alarmHandle = body.value;
                    }
                  }
                );
              });
            }
          });
      },
      // 告警内容
      searchAlarmContent () {
        this.$http
          .post("bma-distribution-service/realTime/searchAlarmContent", {
            dataType: 1,
            projectId: this.projectId,
          })
          .then((res) => {
            // console.log(res);
            this.tableData = res.data;
          });
      },
    },
    beforeDestroy () {
      this.subscribeFields.forEach((i) => {
        this.$clearTimeing(i);
      });
    },
  };
</script>

<style lang="less" scoped>
  .general {
    // padding: 15px 0px 15px 15px;
    width: calc(100% - 30px);
    height: 100%;
    padding: 15px; // width: calc(100% - 20px);

    // height: 100%;
    .change-date {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 140px;
      color: rgba(113, 119, 137, 1);
      font-size: 14px;
      display: flex;
      justify-content: space-between;

      p {
        width: 25px;
        text-align: center;
        cursor: pointer;
        padding-bottom: 6px;

        &.active {
          color: rgba(20, 96, 224, 1);
          border-bottom: 3px solid rgba(20, 96, 224, 1);
        }
      }
    }

    .section1 {
      display: flex;
      justify-content: space-between;
      height: 24%;

      .item1 {
        // width: 596px;
        // height: 204px;
        width: 36%;
        height: 100%;
        position: relative;

        .box {
          display: flex;
          margin-top: 20px;

          .vflex {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 105px;
            width: 150px;
          }

          .left {
            width: 300px; // width: 280px;

            .top {
              font-size: 40px;
              font-weight: 600;
              line-height: 68px;
              color: #1e60cf;
              letter-spacing: 1px;
            }

            .bottom {
              font-size: 14px;
              color: #132742;
            }
          }

          .middle {
            text-align: right;
            padding-right: 30px;
            box-sizing: border-box;

            .top {
              font-size: 23px;
              color: #132742;
              line-height: 70px;
            }

            .bottom {
              font-size: 14px;
              color: #5a8fe8;

              img {
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
                margin-left: 10px;
                margin-right: 2px;
              }
            }
          }

          .br {
            width: 1px;
            height: 105px;
            background: rgba(233, 233, 233, 1);
            margin-left: 10px;
            margin-right: 10px;
          }

          .right {
            align-content: center;
            padding-left: 30px;
            box-sizing: border-box;

            img {
              width: 30px;
              height: 30px;
            }

            .top {
              font-size: 15px;
              color: #181d33;
            }

            .bottom {
              font-size: 23px;
              color: #5a8fe8;
            }
          }
        }
      }

      .item2 {
        width: 38%;
        height: 100%; // width: 606px;

        // height: 204px;
        .box {
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          padding-right: 28px;

          .left {
            display: flex;
            align-items: baseline;

            p {
              &:first-of-type {
                font-size: 50px;
                color: rgba(223, 106, 63, 1);
                margin-right: 40px;
              }

              &:last-of-type {
                font-size: 18px;
                color: rgba(21, 33, 57, 1);
              }
            }
          }

          .middle,
          .right {
            .top {
              display: flex;
              align-items: center;

              .legend {
                width: 22px;
                height: 5px;
                background: rgba(223, 106, 63, 1);
                margin-right: 10px;
              }

              p {
                font-size: 14px;
                letter-spacing: 4px;
                color: rgba(21, 33, 57, 1);
              }
            }

            .bottom {
              align-items: baseline;
              display: flex;
              margin-top: 20px;

              p {
                &:first-of-type {
                  font-size: 26px;
                  font-weight: 500;
                  color: rgba(33, 46, 67, 1);
                  margin-left: 20px;
                  margin-right: 44px;
                  letter-spacing: 2px;
                }

                &:last-of-type {
                  font-size: 16px;
                  color: rgba(21, 33, 57, 1);
                }
              }
            }
          }

          .right {
            .top {
              .legend {
                background: rgba(240, 203, 191, 1);
              }
            }
          }
        }

        .progress {
          width: 100%;
          padding-right: 28px;
          box-sizing: border-box;
          margin-top: 20px;

          .inner {
            height: 8px;
            width: 100%;
            background: rgba(240, 203, 191, 1);
            border-radius: 4px;
            overflow: hidden;

            .pro {
              // width: 100%;
              width: 30%;
              height: 100%;
              border-radius: 4px;
              overflow: hidden;
              background: rgba(223, 106, 63, 1);
            }
          }
        }
      }

      .item3 {
        // width: 412px;
        // height: 204px;
        width: 24%;
        height: 100%;

        .box {
          display: flex;
          justify-content: space-around;
          margin-top: 25px;

          .item {
            display: flex;
            flex-direction: column;
            align-content: center;

            img {
              width: 70px;
              height: 70px;
              margin-bottom: 13px;
            }

            p {
              span {
                font-size: 16px;
                font-weight: 600;

                &:first-of-type {
                  color: rgba(14, 34, 61, 1);
                }

                &:last-of-type {
                  color: rgba(90, 143, 232, 1);
                }
              }
            }
          }
        }
      }
    }

    .section2 {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      height: 48%;
      margin-right: -15px;

      .item1 {
        // width: 1210px;
        // height: 389px;
        width: 99%;
        height: 100%;

        /deep/.table-box {
          margin-top: 20px;
          width: 100%;
          padding-right: 28px;
          box-sizing: border-box;

          .el-table {
            background: rgba(0, 0, 0, 0);

            th {
              background: #f5f5f5;
            }

            tr {
              background: rgba(0, 0, 0, 0);
            }

            th {
              >.cell {
                color: #152139;
                font-size: 16px; // font-size: 14px;
                font-weight: 600;
                text-align: center;
              }
            }

            tr {
              td {
                text-align: center;
                font-size: 14px;
                color: #152139;
              }
            }
          }

          .warnType-box {
            display: flex;
            align-items: center;
            justify-content: center;

            .dot {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              margin-right: 5px;
              background: #fc5959;

              .color1 {
                background: #fc9856;
              }
            }
          }
        }
      }

      .item2 {
        // width: 412px;
        // height: 389px;
        width: 24%;
        height: 100%;

        .item {
          height: 62px;
          display: flex;
          margin: 25px 0;
          cursor: pointer;

          img {
            width: 62px;
            height: 62px;
            z-index: 2;
          }

          .name {
            width: 328px;
            height: 100%;
            background: rgba(240, 242, 249, 1);
            position: relative;
            font-size: 16px;
            color: rgba(21, 33, 57, 1);
            margin-left: -32px;
            line-height: 62px;
            text-indent: 60px;

            p {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-weight: 600;
              width: 250px;
            }

            i {
              position: absolute;
              right: 10px;
              top: 0px;
              font-size: 20px;
              color: rgba(170, 164, 206, 1);
            }
          }
        }
      }
    }

    .btn-out-box {
      display: flex;
      justify-content: space-around;
    }

    .btn-box {
      width: 24px;
      height: 24px;
      background: rgba(165, 165, 165, 0.1);
      border-radius: 50%;
      cursor: pointer;

      .iconfont {
        font-size: 12px;
        color: rgba(195, 195, 195, 1);
      }

      &.download.active {
        background: rgba(20, 96, 224, 0.1);

        .iconfont {
          color: rgba(20, 96, 224, 1);
        }
      }

      &.download:hover {
        background: rgba(20, 96, 224, 0.1);

        .iconfont {
          color: rgba(20, 96, 224, 1);
        }
      }
    }

    .section3 {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;

      .item1 {
        width: 73%; // width: 1210px;
        height: 462px; // height: 100%;
        // width: 70%;
        position: relative;

        .box {
          padding-top: 32px;
          display: flex;
          justify-content: space-between;
          padding-right: 15px;
          box-sizing: border-box;

          .left {
            // width: 800px;
            width: 71%;

            .top {
              display: flex;

              .info {
                width: auto;
                height: 41px;
                border: 1px solid #eaedef;
                border-radius: 21px;
                text-align: center;
                padding: 0px 10px;

                &:first-of-type {
                  margin-right: 33px;
                }

                &:nth-of-type(2) {
                  margin-right: 100px;
                }

                span {
                  line-height: 41px;
                  font-size: 14px;
                  font-weight: 600;

                  &:first-of-type {
                    color: rgba(14, 34, 61, 1);
                  }

                  &:last-of-type {
                    color: rgba(20, 96, 224, 1);
                  }
                }
              }

              .legend {
                display: flex;
                align-items: center;

                .color {
                  width: 12px;
                  height: 12px;
                  background: rgba(20, 96, 224, 1);
                  margin-right: 10px;

                  &.color2 {
                    background: rgba(0, 206, 124, 1);
                  }
                }

                p {
                  // font-size: 14px;
                  font-size: 15px;
                  color: rgba(33, 46, 67, 1);
                }
              }
            }

            .bottom {
              width: 100%; // height: 320px;
              height: 66%;
              border-right: 1px solid rgba(238, 238, 239, 1);
              padding-right: 12px;

              .echarts {
                width: 100%;
                height: 100%;
              }
            }
          }

          .right {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 40px;

            .top {
              width: 235px;
              height: 235px;
              border-radius: 50%;
              background: #fff;
              position: relative;
              box-shadow: 0px 0px 15px rgba(43, 62, 177, 0.07);

              .echarts {
                width: 100%;
                height: 100%;
              }

              .info {
                width: 140px;
                height: 140px;
                background: #f8f8f9;
                border-radius: 50%;
                position: absolute;
                box-shadow: 0px 0px 15px rgba(43, 62, 177, 0.07);
                top: 48px;
                left: 48px;
                text-align: center;

                .value {
                  font-size: 20px;
                  font-weight: 600;
                  line-height: 50px;
                  color: #333;
                  margin-top: 20px;
                }

                .label {
                  font-size: 14px;
                  color: rgba(68, 90, 90, 0.8);
                  line-height: 30px;
                }

                .unit {
                  font-size: 14px;
                  color: rgba(68, 90, 90, 0.8);
                }
              }
            }

            .bottom {
              margin-top: 53px;
              width: 340px;
              display: flex;
              justify-content: space-between;

              .label {
                display: flex;
                align-items: center;

                .color {
                  width: 12px;
                  height: 12px;
                  margin-right: 5px;
                }

                .name {
                  // font-size: 14px;
                  font-size: 15px;
                  color: #212e43;
                }
              }
            }
          }
        }
      }

      .item2 {
        // width: 422px;
        width: 26%;
        height: 462px; // height: 100%;

        // width: 29%;
        .box {
          display: flex;
          flex-wrap: wrap; // padding-top: 8px;
          padding-top: 28px;
          box-sizing: border-box; // height: 33%;

          .item {
            width: 172px;
            height: 113px;
            margin-right: 10px;
            margin-bottom: 14px;
            border: 1px solid #eceef5;
            border-radius: 4px;
            box-sizing: border-box;
            padding: 14px 16px;

            .title {
              display: flex;
              align-items: center;
              letter-spacing: 1px;

              img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
              }

              p {
                font-size: 14px;
                color: rgba(14, 34, 61, 1);
              }
            }

            .bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 20px;

              .left {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 20px;
                height: 18px;

                p {
                  width: 100%;
                  height: 1px;
                  background: rgba(211, 213, 223, 1);
                }
              }

              .right {
                span {
                  &:first-of-type {
                    font-size: 18px;
                    display: inline-block;
                    cursor: pointer;
                    width: auto;
                    max-width: 80px;
                    color: rgba(19, 38, 64, 1);
                  }

                  &:last-of-type {
                    font-size: 12px;
                    color: #0e223d;
                  }
                }
              }
            }
          }
        }
      }
    }

    // 适配界面的样式
    @media screen and (max-width: 1440px) {
      .section1 {
        height: 30%;

        .item1 {
          .box {
            .vflex {
              height: 105px;
              width: 150px;
            }

            .left {
              width: 280px;

              .top {
                font-size: 36px;
                line-height: 64px;
              }

              .bottom {
                font-size: 12px;
              }
            }

            .middle {
              padding-right: 18px;

              .top {
                font-size: 20px;
                line-height: 64px;
              }

              .bottom {
                font-size: 12px;
                color: #5a8fe8;

                img {
                  width: 14px;
                  height: 14px;
                  position: relative;
                  top: 2px;
                  margin-left: 10px;
                  margin-right: 2px;
                }
              }
            }

            .br {
              width: 1px;
              height: 105px;
              background: rgba(233, 233, 233, 1);
              margin-left: 10px;
              margin-right: 10px;
            }

            .right {
              align-content: center;
              padding-left: 24px;
              box-sizing: border-box;

              img {
                width: 30px;
                height: 30px;
              }

              .top {
                font-size: 14px;
                color: #181d33;
              }

              .bottom {
                font-size: 16px;
                color: #5a8fe8;
              }
            }
          }
        }

        .item2 {
          width: 38%;
          height: 100%;

          .box {
            .left {
              p {
                &:first-of-type {
                  font-size: 46px;
                  margin-right: 12px;
                }

                &:last-of-type {
                  font-size: 16px;
                }
              }
            }

            .middle,
            .right {
              .top {
                p {
                  font-size: 12px;
                  letter-spacing: 2px;
                }
              }

              .bottom {
                p {
                  &:first-of-type {
                    font-size: 23px;
                    margin-right: 40px;
                  }

                  &:last-of-type {
                    font-size: 12px;
                  }
                }
              }
            }
          }

          .progress {
            .inner {
              height: 6px;

              .pro {}
            }
          }
        }

        .item3 {
          .box {
            .item {
              img {
                width: 60px;
                height: 60px;
              }

              p {
                span {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }

      .section2 {
        height: 65%;

        .item1 {
          /deep/.table-box {
            padding-right: 0px;
          }
        }
      }

      .section3 {
        height: 65%;

        .item1 {
          height: 100%;
          width: 73%;

          .box {
            .left {
              .top {
                .info {
                  width: auto;
                  padding: 0 20px;

                  &:first-of-type {}

                  &:nth-of-type(2) {
                    margin-right: 20px;
                  }

                  span {
                    font-size: 12px;
                  }
                }

                .legend {
                  .color {
                    &.color2 {}
                  }

                  p {
                    font-size: 12px;
                  }
                }
              }
            }

            .right {
              margin-top: -4px;
              margin-left: -26px;

              .top {
                .info {
                  .value {
                    font-size: 20px;
                  }

                  .label {
                    font-size: 12px;
                  }

                  .unit {
                    font-size: 12px;
                  }
                }
              }

              .bottom {
                margin-top: 30px;
                width: 310px;

                .label {
                  .name {
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }

        .item2 {
          height: 100%;
          width: 26%;

          .box {
            .item {
              width: 45%;
              height: 100%;
              margin-bottom: 12px;
              padding: 13px 14px;

              .title {
                margin: 0px;

                img {
                  width: 23%;
                  height: 23%;
                  margin-right: 6px;
                }

                p {
                  font-size: 12px;
                }
              }

              .bottom {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;

                .left {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  width: 15px;
                  height: 18px;

                  p {
                    width: 100%;
                    height: 1px;
                    background: rgba(211, 213, 223, 1);
                  }
                }

                .right {
                  span {
                    &:first-of-type {
                      font-size: 12px !important;
                      max-width: 55px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>